import { ReactElement } from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { selectSelectedDistrict } from '../../../redux/slices/appSlice';
import { selectLeasWithFileFailures } from '../../../redux/slices/dashboardSlice';
import { appRoutePaths } from '../../../services/route.service';
import DashboardCard from '../DashboardCard/DashboardCard';

const AnnouncementsCard = (): ReactElement => {
  const leasWithFileFailures: Array<string> = useAppSelector(
    selectLeasWithFileFailures
  );
  const { districtId } = useAppSelector(selectSelectedDistrict);

  if (districtId == null || !leasWithFileFailures.includes(districtId)) {
    return <></>;
  } else {
    return (
  <DashboardCard
    cardClassNames="dashboard--grid--badge 
    status--info page--grid--d-6 
    page--grid--m-full"
    messageClassNames="dashboard--info-message"
    message="Important message(s)"
    dataState="fail"
    buttonClassNames="button button--dashboard--small no-wrap-text"
    buttonLink={appRoutePaths.Announcements}
    buttonText={'View Announcements'}
    buttonVisible={true}
    tooltipText={'Click to review errors'}
  />

    );
  }
};

export default AnnouncementsCard;
